import styled from "styled-components";
import themes from "@/styles/themes";
import Icon from '@mdi/react';
import {mdiChevronDown, mdiChevronUp} from '@mdi/js';
import {ReactNode, useState} from "react";

import Events from "@/utils/Events";
import { useSelector} from "react-redux";
import { GET_OFFER_TYPE } from "../../store/slices/offerSlice";

interface IAccordionTitle {
  color?: string
}

const ButtonAccordionShowHidden = styled.button`
  cursor: pointer;
  float: right;
  border: none;
  background: none;
  color: ${themes.estadao};
`
const AccordionHeader = styled.div`
  font-size: 16px;
  color: ${themes.grey};
  cursor: pointer;
  padding: 20px 21px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  transition: 0.4s;
  position: relative;
  

  ${ButtonAccordionShowHidden} {
    svg {
      color: ${themes.grey};
    }
  }

`
const ArccordionTitle = styled.div<IAccordionTitle>`
  display: inline;
  font-weight: 700;
  color:  ${props => props.color ?? themes.greyMedium};
`
const ArccordionPanel = styled.div`
  padding: 0 21px;
  display: none;
  overflow: hidden;
  margin-top: -10px;
  &.show-hidden {
    display: block;
  }
`
const AccordionBody = styled.div`
  margin-bottom: 8px;
  padding: 0;
  background: white;
  border-radius: 8px;
`

interface IAjudaAccordionProps{
  LabelEvent: string
  title: string
  children: ReactNode
  colorTitle?: string
}

export default function AjudaAccordions(parent: IAjudaAccordionProps) {
  const offer_type = useSelector(GET_OFFER_TYPE)
    const [show, setShow] = useState(false);
    const events = new Events();
    return (
        <AccordionBody>
            <AccordionHeader onClick={() => {
                setShow(!show)
                events.trigger(parent.LabelEvent, {show: !show, offer_type })
              }}>
                <ArccordionTitle color={parent.colorTitle}>{parent.title}</ArccordionTitle>
                <ButtonAccordionShowHidden >
                    <Icon path={!show ? mdiChevronDown : mdiChevronUp} size={1}/>
                </ButtonAccordionShowHidden>
            </AccordionHeader>
            <ArccordionPanel className={show ? 'show-hidden' : ''}>
                {parent.children}
            </ArccordionPanel>
        </AccordionBody>
    )
}